export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-10.56278db0.jpg";